import colors from 'vuetify/lib/util/colors.mjs';
import { AppColors } from '@/themes/theme';

export const dpmprColors: Partial<AppColors> = {
  systemPrimary: '#DB2017',
  systemSecondary: '#DB2017',
  buttonPrimary: '#DB2017',
  primary: '#DB2017',
  buttonWarning: '#FF0000',
  buttonConfirm: colors.green.darken2,
  buttonDefault: colors.grey.darken1,
  rdpbackground: '#FFFFFF',
  leftpanelhover: '#DB2017',
};
